import common from '@/services/common'

export default {
  async create(minorID, fileID) {
    console.log("apioverridefile - create(", minorID, fileID, ")")
    const body = {
      minorId: minorID,
      fileId: fileID,
    }
    return common.execute("POST", `/api/appconfig/v1/overridefiles`, body)
  },
  async retrieve(fileID) {
    console.log("apioverridefile - retrieve(", fileID, ")")
    return common.execute("GET", `/api/appconfig/v1/overridefiles/${fileID}`)
  },
  async details(fileID) {
    console.log("apioverridefile - details(", fileID, ")")
    return common.execute("GET", `/api/appconfig/v1/overridefiles/${fileID}/details`).then(result => {
      if (!result.minor) {
        return Object.assign({ minor: {}}, result)
      }
      return result
    })
  },
}